import { validationSchemaLogin } from "../../utils/validationSchemaForm.js";
import { useNavigate } from "react-router-dom";
import { Field, Form, Formik } from "formik";
import MaskedInput from "react-text-mask";
import { rutMask } from "../../utils/inputMask.js";
import React, { useState } from "react";
import DocumentoModal from "./ModalDocumento.jsx";
import { oacento } from "../../utils/caracteresUTF8.js";
import { initialValuesFormNumeroSerie } from "../../utils/initialValues/formNumeroSerie.js";
import { handleSubmitFormNumeroSerie } from "../../utils/handleSubmit/formNumeroSerie.js";
import ModalEjecutivo from "./ModalEjecutivo";
import { GoogleReCaptchaProvider, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import ConfigurationManager from "../../settings/ConfigurationManager.js";
import { Spinner, Button } from "react-bootstrap";
import images from "../../assets/images.tsx";

const FormNumeroSerie = () => {
  const history = useNavigate();
  const [modalShow, setModalShow] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showModalEjecutivo, setShowModalEjecutivo] = useState(false);
  const handleClose = () => setModalShow(false);
  const handleShow = () => setModalShow(true);
  const handleCloseE = () => setShowModalEjecutivo(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const handleSubmit = async (values) => {
    if (!executeRecaptcha) {
      console.error("executeRecaptcha no está disponible");
      return;
    }
    const token = await executeRecaptcha("login");
    handleSubmitFormNumeroSerie({
      values: { ...values, token },
      changeLoading: setIsLoading,
      history: history,
      showModalEjecutivo: setShowModalEjecutivo,
    });
  };

  return (
    <Formik initialValues={initialValuesFormNumeroSerie} validationSchema={validationSchemaLogin} onSubmit={handleSubmit}>
      {(formik) => (
        <Form>
          <div className="mt-2">
            <span>
              RUT del afiliado, pensionado o beneficiario de pensi{oacento}n de
              sobrevivencia
            </span>
            <Field name="rut">
              {({ field, meta }) => (
                <div className="form-group input-wrapper">
                  <MaskedInput
                    {...field}
                    mask={rutMask}
                    type="text"
                    className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""
                      }`}
                    name="rut"
                    aria-describedby="rutAyuda"
                    placeholder=""
                    autoComplete="off"
                  />
                  <label htmlFor="rut" className="control-label">
                    RUT
                  </label>
                  <small
                    id="rutAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error
                      ? meta.error
                      : "Ej. 12.345.678-9."}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="mt-2">
            <span>
              Número de serie o de documento{" "}
              <a onClick={handleShow} className="text-decoration-none align-svg">
                <img src={images.question} alt="question" />
              </a>
            </span>

            <Field name="numeroserie">
              {({ field, meta }) => (
                <div className="form-group input-wrapper">
                  <input
                    {...field}
                    type="text"
                    className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""
                      }`}
                    name="numeroserie"
                    aria-describedby="numeroserieAyuda"
                    placeholder=""
                    autoComplete="off"
                  />
                  <label htmlFor="numeroserie" className="control-label">
                    Numero de Serie
                  </label>
                  <small
                    id="numeroserieAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error
                      ? meta.error
                      : "Ej: A0000000000 o 000.000.000 dependiendo de tu cédula de ID."}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="mt-2">
            <span>Confirmar número de serie o documento </span>
            <Field name="numeroserieCompare">
              {({ field, meta }) => (
                <div className="form-group input-wrapper">
                  <input
                    {...field}
                    type="text"
                    className={`form-control form-control-lg ${meta.touched ? (meta.error ? "is-invalid" : "is-valid") : ""
                      }`}
                    name="numeroserieCompare"
                    aria-describedby="numeroserieCompareAyuda"
                    placeholder=""
                    autoComplete="off"
                  />
                  <label htmlFor="numeroserieCompare" className="control-label">
                    Numero de Serie
                  </label>
                  <small
                    id="numeroserieCompareAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error
                      ? meta.error
                      : "Ej: A0000000000 o 000.000.000 dependiendo de tu cédula de ID."}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="mt-2">
            <Field name="beneficiario">
              {({ field, meta }) => (
                <div className="form-check mb-4">
                  <span className="label-checkbox">
                    Indícanos si eres beneficiario
                  </span>
                  <label
                    className="form-check-label mt-auto"
                    htmlFor="beneficiario"
                  >
                    <input
                      type="checkbox"
                      name="beneficiario"
                      {...field}
                      className="form-check-input"
                      autoComplete="off"
                    />
                    <small className="beneficiario">
                      Soy beneficiario de una Pensión de Sobrevivencia.
                    </small>
                  </label>
                  <small
                    id="terminosAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error ? meta.error : ""}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="mt-2">
            <Field name="mandatario">
              {({ field, meta }) => (
                <div className="form-check">
                  <span className="label-checkbox">
                    Indícanos si eres mandatario
                  </span>
                  <label
                    className="form-check-label mt-auto"
                    htmlFor="mandatario"
                  >
                    <input
                      type="checkbox"
                      name="mandatario"
                      {...field}
                      className="form-check-input"
                      autoComplete="off"
                    />
                    <small className="mandatario">
                      Soy mandatario y estoy facultado para realizar la solicitud.
                    </small>
                  </label>
                  <small
                    id="mandatarioAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error ? meta.error : ""}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="mt-2">
            <Field name="ejecutivoAfp">
              {({ field, meta }) => (
                <div className="form-check">
                  <span className="label-checkbox">
                    Indícanos si eres ejecutivo de la AFP.
                  </span>
                  <label
                    className="form-check-label mt-auto"
                    htmlFor="mandatario"
                  >
                    <input
                      type="checkbox"
                      name="ejecutivoAfp"
                      {...field}
                      className="form-check-input"
                      autoComplete="off"
                    />
                    <small className="mandatario">
                      Hago ingreso asistido de la solicitud como ejecutivo de AFP
                      Modelo.
                    </small>
                  </label>
                  <small
                    id="mandatarioAyuda"
                    className={`form-text ${meta.touched && meta.error ? "is-invalid" : ""
                      }`}
                  >
                    {meta.touched && meta.error ? meta.error : ""}
                  </small>
                </div>
              )}
            </Field>
          </div>

          <div className="justify-content-center d-flex mt-4">
            <Button
              type="submit"
              id="numeroserie"
              variant="success"
              className="col-md-12"
              disabled={!(formik.isValid && formik.dirty) || isLoading}>
              {isLoading ? <Spinner animation="border" variant="light" size="sm" /> : "Continuar"}
            </Button>
          </div>

          <ModalEjecutivo show={showModalEjecutivo} onHide={handleCloseE} />
          <DocumentoModal show={modalShow} onHide={handleClose} />

        </Form>
      )}
    </Formik>
  );
};

const ReCaptcha = () => {
  return (
    <GoogleReCaptchaProvider reCaptchaKey={ConfigurationManager.RECAPTCHA_PUBLIC_KEY}>
      <FormNumeroSerie />
    </GoogleReCaptchaProvider>
  );
};

export default ReCaptcha;
